import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "../styles/LoginModal.css";

const LoginModal = ({ onClose, onShowSignup }) => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState("");
    const modalRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [onClose]);

    const handleLogin = async () => {
        try {
            setMessage("Logging in...");
            setMessageType("info");
            
            const response = await axios.post(
                `${process.env.REACT_APP_AUTH_BASE_URL}/login`,
                { email },
                { 
                    headers: { "Content-Type": "application/json" },
                    validateStatus: (status) => status < 500 // Don't throw for 401 errors
                }
            );

            if (response.data.token) {
                localStorage.setItem("token", response.data.token);
                setMessage("Login successful!");
                setMessageType("success");
                setTimeout(() => window.location.reload(), 1000);
            } else {
                // Handle 401 Unauthorized responses
                const errorMsg = response.data?.errors?.join(', ') || "Invalid credentials";
                setMessage(errorMsg);
                setMessageType("error");
            }
        } catch (error) {
            console.error("Login Error:", error);
            
            // Handle different error types
            if (error.response) {
                // Server responded with error status (4xx/5xx)
                const serverError = error.response.data?.error || 
                                  error.response.data?.message || 
                                  "Login failed";
                setMessage(serverError);
            } else if (error.request) {
                // Request was made but no response
                setMessage("Network error - please try again");
            } else {
                // Other errors
                setMessage("Login failed - please try again");
            }
            setMessageType("error");
        }
    };

    return (
        <div className="modal-overlay">
            <div className="login-modal-content" ref={modalRef}>
                <div className="navbar-logo-container">
                    <p></p>
                </div>

                <div className="modal-body">
                    <input
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && handleLogin()}
                    />
                    
                    <div className="login-link-container">
                        <span>Don't have an account? </span>
                        <span className="login-link" onClick={() => { onClose(); onShowSignup(); }}>
                            Sign up
                        </span>
                    </div>
                    
                    <button onClick={handleLogin}>Login</button>

                    <p className={`message ${messageType}`}>
                        {message}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default LoginModal;
